import React from "react";

import { CropsOverviewTableColumnTitleProps } from "models";

import { Flex, Icon, OverflowEllipsisWithTooltip } from "components";

import { CMC_ROUTES } from "pages/app/crop-mix-composer/CropMixComposerOverlay";

export const TableColumnTitle: React.FC<CropsOverviewTableColumnTitleProps> = ({ title, columnKey, active, direction, currentStep, onClick, className }) => (
  <Flex className="column-title-with-icon" onClick={() => onClick(columnKey)}>
    <OverflowEllipsisWithTooltip title={title} className={`column-title ${className}`} verticalOverflow>
      {title}
    </OverflowEllipsisWithTooltip>
    {currentStep !== CMC_ROUTES.OVERVIEW && (
      <Flex className="sort-icon-container" align="center" justify="center">
        {active ? (
          <Icon iconName={direction === "asc" ? "tabler/arrow-up" : "tabler/arrow-down"} className="sort-icon" size="s" />
        ) : (
          <Icon iconName="tabler/arrow-down" className="sort-icon" size="s" />
        )}
      </Flex>
    )}
  </Flex>
);
